import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

function ActionButtons({
 onClick, onSecondaryClick, isLoading, restrictedFreeUser, disabled,
}) {
  let primaryContent;
  if (isLoading) {
    primaryContent = (
      <>
        <Spinner size="sm" /> Submitting...
      </>
    );
  } else if (restrictedFreeUser) {
    primaryContent = 'Submit pitch';
  } else {
    primaryContent = 'Submit';
  }
  return (
    <div className="action-buttons">
      <button
        className="btn btn-primary btn-lg no-border px-4 py-2 me-2 my-2 font-size-16px"
        type="button"
        onClick={() => onClick()}
        disabled={isLoading || disabled}
      >
        {primaryContent}
      </button>
      <button
        className="btn btn-outline-secondary btn-lg px-4 py-2 me-2 my-2 font-size-16px"
        type="button"
        onClick={() => onSecondaryClick()}
        disabled={isLoading || disabled}
      >
        Discard
      </button>
    </div>
  );
}

ActionButtons.propTypes = {
  onClick: PropTypes.func.isRequired,
  onSecondaryClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  restrictedFreeUser: PropTypes.bool,
  disabled: PropTypes.bool,
};

ActionButtons.defaultProps = {
  isLoading: false,
  restrictedFreeUser: false,
  disabled: false,
};

export default ActionButtons;
